<template>
  <div
    class="flex flex-row rounded-lg px-4 py-2 justify-between w-full mb-2 border border-light-gray"
    :class="[teamMember.isCurrentUser ? 'bg-bkk-50' : 'bg-bkk-10']"
  >
    <div class="text-medium flex flex-row items-center gap-x-2">
      <CrownIcon v-if="isCurrentUserCaptain && teamMember.isTeamCaptain" />
      {{ teamMember.username }}
      <span v-if="isCurrentUserCaptain && teamMember.isInactive">
        ({{ t("comp.challenge.started.tab.team.kick.member.inactive") }})
      </span>
      <button
        v-if="isCurrentUserCaptain && !teamMember.isCurrentUser"
        class="hover:text-red-500"
        @click="
          $emit('kickMember', {
            memberId: teamMember.id,
            memberName: teamMember.username,
          })
        "
      >
        <RemoveMemberIcon />
      </button>
    </div>
    <div class="flex flex-row gap-x-16 items-center">
      <div class="flex flex-col pr-16">
        <div class="font-bold">
          {{
            formatProgressValue(
              rankingSortType === RankingSortType.RANKING_SORT_AVERAGE
                ? teamMember?.averageProgress
                : teamMember?.progress
            )
          }}
        </div>
        <div
          v-if="
            teamChallengeType ===
            CompetitiveChallengeType.COMPETITIVE_CHALLENGE_TYPE_STEPS
          "
        >
          {{
            rankingSortType === RankingSortType.RANKING_SORT_AVERAGE ? "∅" : ""
          }}{{ t("steps.semantics") }}
        </div>
        <div v-else>
          {{
            rankingSortType === RankingSortType.RANKING_SORT_AVERAGE ? "∅" : ""
          }}{{ t("bicycle.semantics") }}
        </div>
      </div>
      <div class="flex flex-col">
        <div class="font-bold">
          {{
            t("comp.challenge.started.tab.ranking.kilogram", {
              s: formatCompetitiveChallengeCo2(
                rankingSortType === RankingSortType.RANKING_SORT_AVERAGE
                  ? teamMember?.averageCo2Saving
                  : teamMember?.co2Saving
              ),
            })
          }}
        </div>
        <div>
          {{
            rankingSortType === RankingSortType.RANKING_SORT_AVERAGE ? "∅" : ""
          }}{{ t("comp.challenge.started.tab.ranking.card.co2.label") }}
        </div>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import { useI18n } from "vue-i18n";
import { CompetitiveChallengeTeamMemberDto } from "../../../dto/competitive-challenge-team-member.dto";
import { CompetitiveChallengeType } from "../../../enum/v2/competitive-challenge-type";
import {
  formatCompetitiveChallengeCo2,
  formatCompetitiveChallengeProgress,
} from "../../../plugins/NumberFormat";
import CrownIcon from "../icon/CrownIcon.vue";
import RemoveMemberIcon from "../icon/RemoveMemberIcon.vue";
import { RankingSortType } from "~/enum/v2/ranking-sort-type.ts";

const { t } = useI18n();

const props = defineProps({
  teamMember: {
    type: Object as () => CompetitiveChallengeTeamMemberDto,
    required: true,
  },
  teamChallengeType: {
    type: String as () => CompetitiveChallengeType,
    required: true,
  },
  rankingSortType: {
    type: String as () => RankingSortType,
    required: true,
  },
  isCurrentUserCaptain: {
    type: Boolean,
    default: false,
  },
  teamName: {
    type: String,
    default: "",
  },
});

defineEmits(["kickMember"]);

function formatProgressValue(value: unknown): string {
  return formatCompetitiveChallengeProgress(value, props.teamChallengeType, {
    roundUp: true,
  });
}
</script>
